import React from 'react';

const StudioDashboard = () => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Studio Dashboard</h1>
      <p>Studio management features coming soon...</p>
    </div>
  );
};

export default StudioDashboard;
